import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';

@NgModule({
    imports: [
      HomeRoutingModule
    ],
    declarations: [
      HomeComponent
    ],
    providers: [],
    exports: [
      HomeComponent
    ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/app/home/home.module.ts